import { withInstall } from '@tav-ui/utils/with-install'
import EditorCustomUploadfileModal from './index.vue'

export * from './types'
export const TaEditorCustomUploadfileModal = withInstall(EditorCustomUploadfileModal)
export default TaEditorCustomUploadfileModal
